import { createSlice } from "@reduxjs/toolkit";

export const kbArticleRelationshipSlice = createSlice({
  name: "kbArticleRelationship",
  initialState: {
    getKbArticleRelationshipResult: false,
    getKbArticleRelationshipLoading: false,
    getKbArticleRelationshipError: false,
  },
  reducers: {
    kbArticleRelationshipReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_KBARTICLERELATIONSHIP":
          return {
            ...state,
            getKbArticleRelationshipResult: payload.data,
            getKbArticleRelationshipLoading: payload.loading,
            getKbArticleRelationshipError: payload.error,
          };
        default:
          return state;
      }
    },
  },
});

export const {
  kbArticleRelationshipReducers,
} = kbArticleRelationshipSlice.actions;

export default kbArticleRelationshipSlice.reducer;
